import { IncomeTaxPersonalChildInRrspOptions } from './income-tax-personal-child-in-rrsp.options';
import {
  IncomeTaxPersonalSpouseInRrspOptions,
} from './income-tax-personal-spouse-in-rrsp.options';
import { validateIf, ValidateNested } from '@pristine-ts/class-validator';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { array } from '@pristine-ts/data-mapping-common';
import { IncomeTaxPersonalOptions } from '../../../income-tax/personal/personal/income-tax-personal.options';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import { IncomeTaxPersonalCommonOptions } from '../../../income-tax/personal/common/income-tax-personal-common.options';
import {advancedFormArray, advancedFormGroup} from "@magieno/common";

@translationBaseKey('income-tax-personal-in-rrsp-options')
export class IncomeTaxPersonalInRrspOptions implements Omit<IncomeTaxPersonalOptions,
  'calculationKeyname' |
  'mainPerson' |
  'spouse' |
  'children' |
  'fiscalYear'
> {

  @advancedFormGroup({
    classType: IncomeTaxPersonalSpouseInRrspOptions,
  })
  @ValidateNested()
  mainPerson: IncomeTaxPersonalSpouseInRrspOptions = new IncomeTaxPersonalSpouseInRrspOptions();

  @advancedFormGroup({
    classType: IncomeTaxPersonalSpouseInRrspOptions,
  })
  @validateIf((options: IncomeTaxPersonalInRrspOptions) => {
    return options.isMarried === true;
  })
  @ValidateNested()
  @validateIf((options, value) => options.isMarried)
  spouse?: IncomeTaxPersonalSpouseInRrspOptions;

  @array(IncomeTaxPersonalChildInRrspOptions)
  @advancedFormArray({
    emptyNumberOfChildrenFormToCreate: 0,
    elementClassType: IncomeTaxPersonalChildInRrspOptions,
  })
  @ValidateNested()
  children: IncomeTaxPersonalChildInRrspOptions[] = [];

  @clonePropertyMetadata(IncomeTaxPersonalCommonOptions, 'isCareExpensesCalculated')
  isCareExpensesCalculated: boolean;

  @clonePropertyMetadata(IncomeTaxPersonalCommonOptions, 'isMarried')
  isMarried: boolean;
}
